import type { FC } from 'react';
import type { LucideIcon } from 'lucide-react';

type IconProps = { icon: string | LucideIcon; className?: string };

export const Icon: FC<IconProps> = ({ icon, className }) => {
	if (typeof icon === 'string') {
		return <span className={className} dangerouslySetInnerHTML={{ __html: icon }} style={{ pointerEvents: 'none' }} />;
	} else {
		const LucideComponent = icon;
		return <LucideComponent className={className} />;
	}
};
